module.exports = __webpack_public_path__ + "img/chart-line.ed488093.svg";